import {
  CommonModule,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  RouterModule,
} from '@angular/router';
import {
  PlaceholderModule,
} from '@o3r/components';
import {
  LocalizationModule,
} from '@o3r/localization';
import {
  BasicLayoutModule,
  DeeplinkChallengeContModule,
  MessagesPanelModule,
} from '@refx/shared-components';
import {
  UiStatusStoreModule,
} from '@refx/shared-store';
import {
  ChallengeComponent,
} from './challenge.component';

@NgModule({
  imports: [
    RouterModule.forChild([{
      path: '',
      component: ChallengeComponent
    }]),
    CommonModule,
    BasicLayoutModule,
    DeeplinkChallengeContModule,
    LocalizationModule,
    MessagesPanelModule,
    UiStatusStoreModule,
    PlaceholderModule
  ],
  declarations: [ChallengeComponent],
  exports: [ChallengeComponent]
})
export class ChallengeModule {}
